import { StanButton } from '@/components';
import { cn } from '@/lib';
import React from 'react';
import { useThemeEditorStore } from '../../stores/themeEditorStore';

import { useCustomizationStore } from '../../stores/customizationStore';
import { StoreItem } from '../../types/store';
import { getItemById } from '../../utils/items';
import { Icon } from '../ui/Icon';

export interface HeaderButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
    label?: string;
    item?: StoreItem;
}

export const HeaderButton = ({ children, className, label, item, ...rest }: HeaderButtonProps) => {
    const { reorder, storeItems } = useCustomizationStore();
    const { editBlockId } = useThemeEditorStore();

    // Use provided item, or fetch block by editBlockId
    const block = item || (editBlockId ? getItemById(editBlockId, storeItems) : null);

    return (
        <div className='flex w-full items-center justify-between gap-2'>
            <button
                type='button'
                className={cn(
                    'inline-flex flex-shrink-0 items-center gap-1 overflow-hidden text-[24px] whitespace-nowrap',
                    rest.onClick && 'cursor-pointer',
                    className
                )}
                {...rest}
            >
                {rest.onClick && <Icon name='chevron' />}
                {label && <span className='overflow-hidden text-[16px] text-ellipsis md:text-[18px]'>{label}</span>}
                {children}
            </button>
            {block && (
                <div className='flex w-full flex-nowrap items-center justify-end gap-2'>
                    <StanButton
                        name='move-up'
                        onClick={() => reorder(Number(block.id), block?.order - 1)}
                        disabled={block?.order === 0}
                        color='dark'
                        variant='link'
                        size='sm'
                        className='!m-0 !h-auto !p-0'
                    >
                        <Icon name='arrow' className='text-semantic-fg-muted text-[24px]' />
                    </StanButton>
                    <StanButton
                        name='move-down'
                        onClick={() => reorder(Number(block.id), block?.order + 1)}
                        color='dark'
                        variant='link'
                        size='sm'
                        className='!m-0 !h-auto !p-0'
                        disabled={block?.order === storeItems.length - 1}
                    >
                        <span style={{ transform: 'rotate(180deg)' }}>
                            <Icon name='arrow' className='text-semantic-fg-muted text-[24px]' />
                        </span>
                    </StanButton>
                </div>
            )}
        </div>
    );
};
